import gql from 'graphql-tag';

import type { LongFormDraft } from 'src/data/longForm/types';
import { executeGqlMutation } from 'src/graphql/client';
import type { BackendMutationRetryComplianceForLongFormDraftArgs } from 'src/types/backend';

import { FRAGMENT_LONG_FORM_BUILDER_DRAFT } from './schema';

interface RetryComplianceForLongFormDraftResult {
  draft: LongFormDraft;
  retriedCount: number;
  errors: string[];
}

const MUTATION = gql`
  mutation RetryComplianceForLongFormDraft($id: ID!) {
    retryComplianceForLongFormDraft(id: $id) {
      draft {
        ...LongFormBuilderDraft
      }
      retriedCount
      errors
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
`;

type Variables = BackendMutationRetryComplianceForLongFormDraftArgs;

export const retryComplianceForLongFormDraft = async (
  variables: Variables
): Promise<RetryComplianceForLongFormDraftResult | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  const payload = result.data?.retryComplianceForLongFormDraft;
  if (!payload) {
    return undefined;
  }
  return {
    draft: payload.draft,
    retriedCount: payload.retriedCount,
    errors: payload.errors ?? [],
  };
};
